import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet"; // You may need to install this package
import heroImage from "./../../../assets/images/advanced-stm1.jpg";
import favicon from "./../../../assets/images/favicon.ico";

import "./advancedhair.css";
//bannerimg
import stm1 from "./../../../assets/images/advanced-stm.jpg";
//before and after
import stm2 from "./../../../assets/images/advanced-stm2.jpg";
import stm3 from "./../../../assets/images/advanced-stm.jpg";
import stm4 from "./../../../assets/images/advanced-stm.jpg";

// Import icons
import groHairIcon from "./../../../assets/images/grow-hair treatment-icons.png";
import prpIcon from "./../../../assets/images/prp-treatment-icons1.png";
import gfcIcon from "./../../../assets/images/gfc-treatment-icons.png";
import stmIcon from "./../../../assets/images/treatment.png";
import laserIcon from "./../../../assets/images/laserhair.png";
      import AutoScrollImageRow from "./AutoScrollImageRow";


const treatments = [
  { name: "GROHAIR TREATMENT", navName: "GROHAIR" },
  { name: "PRP TREATMENT", navName: "PRP" },
  { name: "GFC TREATMENT", navName: "GFC" },
  { name: "STM TREATMENT", navName: "STM" },
  { name: "LASER TREATMENT", navName: "LASER" },
];

const treatmentIconPNGMap = {
  GROHAIR: groHairIcon,
  PRP: prpIcon,
  GFC: gfcIcon,
  STM: stmIcon,
  LASER: laserIcon,
};

const images = [
  { 
    src: stm2, 
    alt: "Before and After STM Hair Treatment Results", 
    title: "STM Treatment Results Comparison" 
  },
  { 
    src: stm3, 
    alt: "STM Hair Treatment Procedure", 
    title: "Professional STM Hair Therapy Process" 
  },
  { 
    src: stm4, 
    alt: "Advanced STM Hair Treatment Equipment", 
    title: "State-of-the-art STM Technology" 
  }
];

const faqData = [
  {
    q: "What makes STM hair treatment unique?",
    a: "STM uses plant-based growth factors with a non-invasive transdermal system, making it ideal for sensitive scalps and those who prefer natural hair regrowth therapies.",
  },
  {
    q: "Is STM treatment safe for all hair types?",
    a: "Yes! STM is 100% safe, chemical-free, and suitable for all hair types and genders.",
  },
  {
    q: "How many sessions are typically needed?",
    a: "Most people see noticeable results after a few sessions, but your dermatologist will suggest a tailored treatment plan based on your scalp condition.",
  },
  {
    q: "Does STM treatment involve pain or injections?",
    a: "No. STM is a completely painless procedure with no needles or surgery involved.",
  },
  {
    q: "Can STM help with post-pregnancy or stress-related hair fall?",
    a: "Yes. STM is highly effective in addressing hormonal and stress-related hair thinning by rejuvenating dormant follicles.",
  },
];

// Contact information constant
const contactInfo = {
  phone: "+918870001377",
  email: "info@h-cura.com",
  hours: "Mon-Sat: 9am-8pm, Sun: 10am-4pm",
  locations: [
    {
      city: "Bangalore",
      area: "Jayanagar",
      state: "Karnataka",
      postalCode: "560041"
    },
    {
      city: "Chennai",
      area: "Valasaravakkam",
      state: "Tamil Nadu",
      postalCode: "600087"
    }
  ],
  socialMedia: {
    facebook: "https://www.facebook.com/hcuraclinic",
    instagram: "https://www.instagram.com/hcuraclinic",
    twitter: "https://twitter.com/hcuraclinic"
  }
};

// Benefits data constant
const benefitsData = [
  {
    icon: "🔬",
    title: "State-of-the-Art Technology",
    desc: "We deploy the latest in STM and growth factor science to deliver natural hair regeneration results.",
    features: [
      "Innovative Treatment Protocols",
      "FDA-Approved Procedures",
      "Clinically Proven Results",
    ],
  },
  {
    icon: "👨‍⚕",
    title: "Expert Medical Team",
    desc: "Our board-certified specialists are experts in hair restoration and are dedicated to your care.",
    features: [
      "Highly Trained Professionals",
      "Years of Experience",
      "Personalized Attention",
    ],
  },
  {
    icon: "🎯",
    title: "Customized Therapy",
    desc: "Every treatment plan is tailored to your genetic profile and hair restoration goals.",
    features: [
      "Individualized Sessions",
      "Continuous Progress Tracking",
      "Optimized Treatment Frequency",
    ],
  },
  {
    icon: "✨",
    title: "Natural-Looking Results",
    desc: "Achieve fuller, healthier hair that looks completely natural with our STM solutions.",
    features: [
      "Subtle Enhancements",
      "Long-Lasting Benefits",
      "Effortless Aesthetics",
    ],
  },
  {
    icon: "🛡",
    title: "Safety First",
    desc: "Our treatments meet the highest medical standards, ensuring a safe and sterile environment at all times.",
    features: [
      "Medical-Grade Facilities",
      "Strict Safety Protocols",
      "Patient-Centric Care",
    ],
  },
  {
    icon: "💯",
    title: "Proven Success",
    desc: "Join thousands of clients who have experienced astonishing hair regeneration results with H-Cura.",
    features: [
      "Over 5000 Happy Clients",
      "Remarkable Clinical Outcomes",
      "Consistently High Success Rates",
    ],
  },
];

// Process steps constant
const processSteps = [
  {
    step: "01",
    title: "In-Depth Consultation",
    desc: "Kick off your journey with a thorough consultation to assess your scalp health and treatment goals.",
    details: [
      "Detailed scalp analysis",
      "Personal health review",
      "Customized treatment roadmap",
      "Expectation setting",
    ],
    icon: "🔍",
  },
  {
    step: "02",
    title: "Tailored Treatment Planning",
    desc: "Our team collaborates with you to design a bespoke STM treatment plan that best suits your hair needs.",
    details: [
      "Personalized regimen design",
      "Optimized treatment protocol",
      "Session scheduling",
      "Lifestyle coaching",
    ],
    icon: "📋",
  },
  {
    step: "03",
    title: "Expert STM Session",
    desc: "Experience our precise application techniques as we apply concentrated growth factors to trigger natural regrowth.",
    details: [
      "Sterile preparation",
      "Precision STM application",
      "Targeted hair follicle activation",
      "Comfort-focused procedure",
    ],
    icon: "💉",
  },
  {
    step: "04",
    title: "Comprehensive Aftercare",
    desc: "Benefit from our dedicated follow-up care, ensuring your progress is monitored and optimized.",
    details: [
      "Routine progress reviews",
      "Adaptive treatment refinement",
      "Maintenance plans",
      "Long-term support",
    ],
    icon: "📈",
  },
];

// Treatment details constant
const treatmentDetails = {
  stm: {
    title: "What is STM (Stem Cell Transdermal Method) Hair Treatment",
    description: "STM (Stem Cell Transdermal Method) is a non-invasive scalp rejuvenation therapy that uses plant-derived stem cell growth factors, multivitamins, peptides, and amino acids. Delivered through a gentle transdermal system, STM revitalizes follicles, enhances circulation, and promotes new hair growth naturally—no surgery, no pain, and perfect for early hair thinning, pattern hair loss, and stress-related shedding.",
    idealFor: [
      "Men and women with pattern hair loss",
      "Individuals facing diffuse thinning or stress-related shedding",
      "Postpartum hair fall recovery",
      "Those seeking a non-invasive hair restoration solution"
    ],
    highlightInfo: "Experience scientifically proven, needle-free, non-invasive hair regrowth with Advanced GroHair Treatment at H‑Cura Multispecialty Clinic. Now available at our Jayanagar (Bangalore) and Valasaravakkam (Chennai) branches, this FDA-approved French electroporation therapy delivers nourishing serums and DHT blockers directly into the scalp, promoting hair volume, thickness, and confidence—all without injections or surgery.",
    benefits: [
      {
        icon: "🔬",
        title: "Revitalize Dormant Follicles",
        desc: "Based on Plant poly peptides"
      },
      {
        icon: "📈",
        title: "Boost Hair Density",
        desc: "supports tissue repair."
      },
      {
        icon: "🌱",
        title: "Promote Natural Regeneration",
        desc: "Long-lasting result."
      },
      {
        icon: "💪",
        title: "Strengthen Existing Hair",
        desc: "Reduce breakage and revitalize hair quality."
      }
    ],
    stats: [
      {
        title: "Client Success Rate",
        value: "95%",
        subtitle: "Satisfied Clients"
      },
      {
        title: "Result",
        value: "6-10 sessions",
        subtitle: "for visible results"
      },
      {
        title: "Session Duration",
        value: "60 mins",
        subtitle: "Per Treatment"
      },
      {
        title: "Minimal Recovery",
        value: "Quick",
        subtitle: "Rapid Return to Routine"
      }
    ]
  }
};

// All schema data consolidated in one object
const schemaData = {
  // Create the FAQ schema JSON
  faqSchema: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.a
      }
    }))
  },

  // Create Organization schema JSON
  organizationSchema: {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "H-Cura Multispeciality Clinic",
    "url": "https://www.h-cura.com",
    "logo": "https://www.h-cura.com/logo.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": contactInfo.phone,
      "contactType": "customer service",
      "availableLanguage": ["English", "Tamil"]
    },
    "sameAs": [
      contactInfo.socialMedia.facebook,
      contactInfo.socialMedia.instagram,
      contactInfo.socialMedia.twitter
    ]
  },

  // Create Service schema JSON
  serviceSchema: {
    "@context": "https://schema.org",
    "@type": "MedicalProcedure",
    "name": "STM Hair Treatment",
    "procedureType": "Hair Restoration Therapy",
    "howPerformed": "Non-invasive transdermal application of plant-derived stem cell growth factors",
    "preparation": "Detailed scalp analysis and personalized treatment plan",
    "followup": "Routine progress reviews and maintenance plans",
    "bodyLocation": "Scalp",
    "medicalSpecialty": {
      "@type": "MedicalSpecialty",
      "name": "Dermatology"
    },
    "performedBy": {
      "@type": "MedicalOrganization",
      "name": "H-Cura Multispeciality Clinic"
    }
  },

  // Create Local Business schema JSON
  localBusinessSchema: {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "H-Cura Multispeciality Clinic",
    "image": "https://www.h-cura.com/clinic-image.jpg",
    "telephone": contactInfo.phone,
    "email": contactInfo.email,
    "url": "https://www.h-cura.com",
    "description": "H-Cura is a leading multispeciality clinic offering advanced hair treatments including STM, PRP, GFC, GroHair, and Laser therapies with locations in Bangalore and Chennai.",
    "address": contactInfo.locations.map(location => ({
      "@type": "PostalAddress",
      "streetAddress": location.area,
      "addressLocality": location.city,
      "addressRegion": location.state,
      "postalCode": location.postalCode,
      "addressCountry": "IN"
    })),
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "12.9279",
      "longitude": "77.5937"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "09:00",
        "closes": "20:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Sunday"],
        "opens": "10:00",
        "closes": "16:00"
      }
    ],
    "medicalSpecialty": ["Dermatology", "Trichology"],
    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "STM Hair Treatment",
        "procedureType": "Non-invasive Hair Restoration"
      },
      {
        "@type": "MedicalProcedure",
        "name": "PRP Treatment",
        "procedureType": "Regenerative Hair Therapy"
      },
      {
        "@type": "MedicalProcedure",
        "name": "GFC Treatment",
        "procedureType": "Growth Factor Concentrate Therapy"
      },
      {
        "@type": "MedicalProcedure",
        "name": "GroHair Treatment",
        "procedureType": "Advanced Hair Stimulation"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Laser Hair Treatment",
        "procedureType": "Low-Level Laser Therapy"
      }
    ],
    "priceRange": "₹₹₹"
  },

  // Create WebPage schema JSON
  webPageSchema: {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "STM Hair Treatment in India | Advanced Hair Regrowth Therapy",
    "description": "H-Cura offers advanced STM Hair Treatment in Bangalore & Chennai. Non-invasive, painless therapy using plant-based stem cell technology for hair regrowth.",
    "url": "https://www.h-cura.com/advanced-stm-treatment",
    "isPartOf": {
      "@type": "WebSite",
      "name": "H-Cura Multispeciality Clinic",
      "url": "https://www.h-cura.com"
    },
    "about": {
      "@type": "MedicalProcedure",
      "name": "STM Hair Treatment",
      "procedureType": "Hair Restoration Therapy"
    },
    "specialty": "Hair Restoration",
    "audience": {
      "@type": "Audience",
      "audienceType": "People suffering from hair loss"
    },
    "provider": {
      "@type": "MedicalOrganization",
      "name": "H-Cura Multispeciality Clinic"
    }
  },

  // Create BreadcrumbList schema JSON
  breadcrumbSchema: {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.h-cura.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Hair Treatments",
        "item": "https://www.h-cura.com/hair-treatments"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "STM Hair Treatment",
        "item": "https://www.h-cura.com/advanced-stm-treatment"
      }
    ]
  },

  // Create Article schema JSON
  articleSchema: {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "headline": "STM Hair Treatment - Advanced Hair Regrowth Therapy",
    "datePublished": "2023-03-15T08:00:00+05:30",
    "dateModified": "2023-07-22T10:30:00+05:30",
    "author": {
      "@type": "Organization",
      "name": "H-Cura Multispeciality Clinic"
    },
    "publisher": {
      "@type": "Organization",
      "name": "H-Cura Multispeciality Clinic",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.h-cura.com/logo.png"
      }
    },
    "description": "Learn about STM Hair Treatment, a non-invasive hair restoration therapy using plant-derived stem cells for natural hair regrowth.",
    "mainEntityOfPage": "https://www.h-cura.com/advanced-stm-treatment",
    "speakable": {
      "@type": "SpeakableSpecification",
      "cssSelector": [".hc-hero-content", ".hc-what-is-grohair-inner"]
    },
    "specialty": "Dermatology"
  },

  // Create Review schema JSON
  reviewSchema: {
    "@context": "https://schema.org",
    "@type": "Review",
    "itemReviewed": {
      "@type": "MedicalProcedure",
      "name": "STM Hair Treatment",
      "procedureType": "Hair Restoration Therapy",
      "performedBy": {
        "@type": "MedicalOrganization",
        "name": "H-Cura Multispeciality Clinic"
      }
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "4.8",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Rajesh Kumar"
    },
    "reviewBody": "I've tried many hair treatments before, but STM at H-Cura gave me visible results in just a few sessions. The procedure was completely painless and the staff was extremely professional.",
    "datePublished": "2023-05-12"
  },
  
  // Create HowTo schema for the treatment process
  howToSchema: {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "STM Hair Treatment Process at H-Cura",
    "description": "Step-by-step guide to the STM hair treatment process at H-Cura Multispeciality Clinic",
    "totalTime": "PT1H30M",
    "estimatedCost": {
      "@type": "MonetaryAmount",
      "currency": "INR",
      "value": "5000"
    },
    "step": processSteps.map((step, index) => ({
      "@type": "HowToStep",
      "position": index + 1,
      "name": step.title,
      "text": step.desc,
      "itemListElement": step.details.map(detail => ({
        "@type": "HowToDirection",
        "text": detail
      }))
    }))
  },
  
  // Create Product schema for STM Treatment
  productSchema: {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "STM Hair Treatment",
    "description": "Non-invasive hair restoration therapy using plant-derived stem cell growth factors",
    "brand": {
      "@type": "Brand",
      "name": "H-Cura"
    },
    "offers": {
      "@type": "Offer",
      "price": "5000",
      "priceCurrency": "INR",
      "availability": "https://schema.org/InStock"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    }
  },
  
  // Create MedicalCondition schema for hair loss
  medicalConditionSchema: {
    "@context": "https://schema.org",
    "@type": "MedicalCondition",
    "name": "Hair Loss",
    "alternateName": ["Alopecia", "Baldness", "Hair Thinning"],
    "description": "Hair loss or alopecia refers to a condition where there is noticeable thinning of hair from the scalp or other parts of the body.",
    "possibleTreatment": {
      "@type": "MedicalTherapy",
      "name": "STM Hair Treatment",
      "description": "Non-invasive hair restoration therapy using plant-derived stem cell growth factors"
    }
  },

  // Create ContactPage schema
  contactPageSchema: {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact H-Cura Multispeciality Clinic",
    "description": "Get in touch with H-Cura for hair treatment consultations and appointments.",
    "url": "https://www.h-cura.com/contact",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": contactInfo.phone,
        "contactType": "customer service",
        "areaServed": ["Bangalore", "Chennai"],
        "availableLanguage": ["English", "Tamil"],
        "email": contactInfo.email
      }
    ],
    "location": contactInfo.locations.map(location => ({
      "@type": "Place",
      "name": `H-Cura ${location.city} Clinic`,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": location.area,
        "addressLocality": location.city,
        "addressRegion": location.state,
        "postalCode": location.postalCode,
        "addressCountry": "IN"
      }
    })),
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "09:00",
        "closes": "20:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Sunday"],
        "opens": "10:00",
        "closes": "16:00"
      }
    ]
  },

  // Create SiteNavigationElement schema for footer links
  siteNavigationSchema: {
    "@context": "https://schema.org",
    "@type": "SiteNavigationElement",
    "name": "H-Cura Website Navigation",
    "description": "Main navigation links for H-Cura Multispeciality Clinic website",
    "url": "https://www.h-cura.com",
    "hasPart": [
      {
        "@type": "SiteNavigationElement",
        "name": "GroHair Treatment",
        "url": "https://www.h-cura.com/advanced-grow-hair-treatment"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "PRP Treatment",
        "url": "https://www.h-cura.com/advanced-hair-prp-treatment"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "GFC Treatment",
        "url": "https://www.h-cura.com/advanced-hair-gfc-treatment"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "STM Treatment",
        "url": "https://www.h-cura.com/advanced-stm-treatment"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Laser Treatment",
        "url": "https://www.h-cura.com/advanced-laser-treatment"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Book Consultation",
        "url": "https://www.h-cura.com/bookconsultation"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Privacy Policy",
        "url": "https://www.h-cura.com/privacy-policy"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Terms of Service",
        "url": "https://www.h-cura.com/terms-of-service"
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Sitemap",
        "url": "https://www.h-cura.com/sitemap"
      }
    ]
  }
};

function Hair() {
  const [activeTab, setActiveTab] = useState("STM TREATMENT");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Get the current path from window.location
    const path = window.location.pathname;

    // Extract the treatment name from the path
    const pathSegments = path.split("/");
    const currentPage = pathSegments[pathSegments.length - 1]?.toLowerCase();

    // Find the matching treatment based on the URL path
    if (currentPage) {
      const matchingTreatment = treatments.find(
        (treatment) => treatment.navName.toLowerCase() === currentPage
      );

      if (matchingTreatment) {
        setActiveTab(matchingTreatment.name);
      }
    }

    // Original effect code for process steps
    const steps = document.querySelectorAll(".hc-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const renderTreatmentIcon = (name, fallbackIcon) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={`${name} Hair Treatment Icon`}
        title={`${name} Hair Treatment Option`}
        style={{ width: "100px", height: "100px" }}
      />
    ) : (
      fallbackIcon
    );
  };

  const openModal = (image) => {
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  // Updated handleTreatmentClick function with the new URL pattern
  const handleTreatmentClick = (treatment) => {
    setActiveTab(treatment.name);
    // Map treatment names to specific URLs
    const treatmentUrlMap = {
      "GROHAIR TREATMENT": "/advanced-grow-hair-treatment",
      "PRP TREATMENT": "/advanced-hair-prp-treatment",
      "GFC TREATMENT": "/advanced-hair-gfc-treatment",
      "STM TREATMENT": "/advanced-stm-treatment",
      "LASER TREATMENT": "/advanced-laser-treatment"
    };
    
    // Use the mapped URL if available, otherwise fallback to the original pattern
    const url = treatmentUrlMap[treatment.name] || `/home/${treatment.navName.toLowerCase()}`;
    console.log("Navigating to:", url); // Debug log
    navigate(url);
  };

  return (
    <div className="hc-wrapper">
      {/* SEO and Schema Markup using React Helmet */}
      <Helmet>
        <title>STM Treatment in India | Advanced Hair Regrowth Therapy - H-Cura</title>
        <meta name="description" content="H-Cura Multispeciality Clinic offers advanced STM Hair Treatment in Bangalore & Chennai. Non-invasive, painless hair regrowth therapy using plant-based stem cell technology. Effective solution for pattern baldness, thinning hair, and stress-related hair loss. Book your consultation today: +918870001377" />
        <meta name="keywords" content="H-Cura, Multispeciality Clinic, STM hair treatment, Bangalore hair clinic, Chennai hair restoration, Stem Cell Transdermal Method, hair regrowth therapy, non-invasive hair treatment, hair loss solution, pattern baldness treatment, plant-based hair therapy, painless hair treatment" />
        
        {/* Robots Tag - Explicitly allow indexing */}
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta name="bingbot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        
        <meta name="author" content="H-Cura Multispeciality Clinic" />
        <link rel="canonical" href="https://www.h-cura.com/advanced-stm-treatment" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="H-Cura Multispeciality Clinic | Advanced STM Hair Treatment" />
        <meta property="og:description" content="Revolutionary non-invasive hair restoration using plant-derived stem cell technology at H-Cura Multispeciality Clinic. Safe, painless, and effective for all hair types." />
        <meta property="og:image" content="https://www.h-cura.com/stm-treatment-image.jpg" />
        <meta property="og:url" content="https://www.h-cura.com/advanced-stm-treatment" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="H-Cura Multispeciality Clinic" />
        <meta property="og:locale" content="en_US" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="H-Cura Multispeciality Clinic | Advanced STM Hair Treatment" />
        <meta name="twitter:description" content="Revolutionary non-invasive hair restoration using plant-derived stem cell technology at H-Cura. Safe, painless, and effective for all hair types." />
                <meta name="twitter:image" content="https://www.h-cura.com/stm-treatment-image.jpg" />
        <meta name="twitter:site" content="@hcuraclinic" />
        
        {/* Favicon */}
        <link rel="icon" type="image/x-icon" href={favicon} />
        
        {/* Schema.org JSON-LD structured data */}
        <script type="application/ld+json">
          {JSON.stringify(schemaData.faqSchema)}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData.organizationSchema)}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData.serviceSchema)}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData.localBusinessSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(schemaData.webPageSchema)}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData.breadcrumbSchema)}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData.articleSchema)}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData.reviewSchema)}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData.howToSchema)}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData.productSchema)}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData.medicalConditionSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(schemaData.contactPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(schemaData.siteNavigationSchema)}
        </script>
      </Helmet>

      {/* New Navigation Section */}
      <div className="hc-treatment-nav-container">
        <h2>Explore Our Treatments</h2>
        <div className="hc-treatment-nav-cards">
          {treatments.map((treatment) => (
            <div
              key={treatment.name}
              className={`hc-treatment-nav-card ${
                activeTab === treatment.name ? "active" : ""
              }`}
              style={{
                position: "relative",
                borderBottom:
                  activeTab === treatment.name ? "3px solid #007bff" : "none",
                transition: "border-bottom 0.3s ease",
              }}
              onClick={() => handleTreatmentClick(treatment)}
            >
              <div className="hc-card-icon">
                {renderTreatmentIcon(treatment.navName)}
              </div>
              <div
                className="hc-card-title"
                style={{
                  color: ["GROHAIR", "PRP", "GFC", "STM", "LASER"].includes(
                    treatment.navName
                  )
                    ? "#007bff"
                    : "black",
                }}
              >
                {treatment.name.replace(" TREATMENT", "")}
                <span style={{ color: "black" }}> TREATMENT</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Hero Section */}
      <section
        className="hc-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
        title="STM Hair Treatment Hero Banner"
      >
        <div className="hc-hero-content">
          <h1 className="hc-hero-title">
            STM Hair Treatment in Bangalore & Chennai – Hair Regrowth Therapy
          </h1>
          <p className="hc-hero-text">
            Harness the power of your own platelets to naturally rejuvenate your
            scalp and restore hair density.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="hc-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      {/* Treatment Section */}
      <section className="hc-treatment-section" id="treatments">
        <div className="hc-treatment-container">
          <div className="hc-treatment-nav">
            <h2>Help Your Hair with Our Advanced Treatments</h2>
            <p className="hc-nav-description">
              From growth factor enhancements to exclusive Stm therapies, each
              treatment is engineered to kickstart your natural hair regrowth.
            </p>
            <ul>
              <li className="hc-active">
                <strong>Gro Hair Therapy</strong>
                <p>Stimulate hair follicles & helps in hair regrowth.</p>
                <ul className="hc-treatment-details">
                  <li>painless proess & noninvasive procedure</li>
                  <li>helps in control hairfall</li>
                  <li>Quick visible results</li>
                  <li>reduce dandruff</li>
                </ul>
              </li>
              <li className="hc-active">
                <strong>Growth Factor Therapy</strong>
                <p>Stimulate hair follicles & helps in hair regrowth.</p>
                <ul className="hc-treatment-details">
                  <li>Clinical proven and tested</li>
                  <li>Minimal procedure</li>
                  <li>Quick visible results</li>
                  <li>
                    Enrich with Biotin, Zinc, Minerals and other Vitamins
                  </li>
                </ul>
              </li>
              <li>
                <strong>Prp Therapy</strong>
                <p>
                  Restore your hair naturally by plasma rich protein therapy.
                </p>
                <ul className="hc-treatment-details">
                  <li>Autologous treatment</li>
                  <li>No synthetic additives</li>
                  <li>Boosts regeneration</li>
                </ul>
              </li>

              <li>
                <strong>Stem Cell Treatment</strong>
                <p>Rejuvenate your hair using regenerative technology.</p>
                <ul className="hc-treatment-details">
                  <li>Based on plant poly peptides</li>
                  <li>Supports tissue repair</li>
                  <li>Long-lasting results</li>
                </ul>
              </li>
              <li>
                <strong>Laser Hair Therapy</strong>
                <p>Enhance hair density with precision laser treatments.</p>
                <ul className="hc-treatment-details">
                  <li>Pain-free procedure</li>
                  <li>It stimulate hair follicles</li>
                  <li>hair boosting therapy</li>
                  <li>Quick sessions</li>
                </ul>
              </li>
            </ul>
            <p className="hc-treatment-description-text">
              Our state-of-the-art therapies are administered by experienced
              specialists.
            </p>
            <p className="hc-treatment-extra-info">
              Book a consultation today to create your personalized treatment
              plan.
            </p>
          </div>

          <div className="hc-treatment-content">
            <h3>Advanced STM Treatment</h3>
            <div className="hc-treatment-info">
              <div className="hc-treatment-images">
                <img
                  src={stm1}
                  alt="Advanced STM Hair Treatment Process"
                  title="STM Hair Restoration Therapy"
                  className="hc-main-treatment-image"
                />
                <div className="hc-treatment-gallery">
                  {images.map((image, index) => (
                    <img
                      key={index}
                      src={image.src}
                      alt={image.alt}
                      title={image.title}
                      onClick={() => openModal(image)}
                    />
                  ))}
                </div>
              </div>
              <div className="hc-treatment-highlight-info">
                {treatmentDetails.stm.highlightInfo}
              </div>

              <div className="hc-treatment-description">
                <h4>Empowering Hair Regrowth with Science</h4>
                <div className="hc-treatment-intro">
                  <Link
                    to="/bookconsultation"
                    style={{ textDecoration: "none" }}
                  >
                    <span className="hc-highlight-tag">INNOVATIVE STM</span>
                  </Link>{" "}
                  <p className="hc-lead-text">
                    Our breakthrough technology fuses advanced growth factors
                    with your body's own healing proteins to restore thicker,
                    healthier hair.
                  </p>
                </div>

                <div className="hc-key-benefits">
                  <h5>Transformative Benefits of Our STM Approach</h5>
                  <p>
                    Our method leverages state-of-the-art STM technology to:
                  </p>
                  <ul>
                    {treatmentDetails.stm.benefits.map((benefit, index) => (
                      <li key={index}>
                        <span className="hc-benefit-icon">{benefit.icon}</span>
                        <strong>{benefit.title}</strong>
                        <p>{benefit.desc}</p>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="hc-treatment-highlights">
                  {treatmentDetails.stm.stats.map((stat, index) => (
                    <div className="hc-highlight-box" key={index}>
                      <h5>{stat.title}</h5>
                      <p>{stat.value}</p>
                      <span className="hc-subtitle">{stat.subtitle}</span>
                    </div>
                  ))}
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="hc-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="hc-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hc-what-is-grohair">
        <div className="hc-what-is-grohair-inner">
          <h2 className="hc-what-is-grohair-title">
            {treatmentDetails.stm.title}
          </h2>
          <p className="hc-what-is-grohair-desc">
            {treatmentDetails.stm.description}
          </p>
          <p className="hc-what-is-grohair-desc">
            This treatment is ideal for:
          </p>
          <ul className="hc-what-is-grohair-list">
            {treatmentDetails.stm.idealFor.map((item, index) => (
              <li key={index}>✅ {item}</li>
            ))}
          </ul>
          <p className="hc-what-is-grohair-desc">
            At H‑Cura, we combine the latest technology with expert medical care to deliver excellent results safely and comfortably.
          </p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="hc-benefits-section">
        <div className="hc-benefits-header">
          <span className="hc-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic </h2>
          <p className="hc-section-subtitle">
            Our advanced treatments combine cutting-edge science with
            personalized care to restore your hair and confidence.
          </p>
        </div>
        <div className="hc-benefits-grid">
          {benefitsData.map((benefit, index) => (
            <div className="hc-benefit-card" key={index}>
              <div className="hc-benefit-icon">{benefit.icon}</div>
              <div className="hc-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="hc-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Process Section */}
      <section className="hc-process-section" id="process">
        <div className="hc-process-header">
          <span className="hc-process-tag">Our Process</span>
          <h2>Your Journey to Fuller Hair with H-Cura</h2>
          <p className="hc-process-subtitle">
            Embrace our comprehensive 4-step approach for sustainable hair
            restoration.
          </p>
        </div>
        <div className="hc-process-timeline">
          {processSteps.map((process, index) => (
            <div className="hc-process-step" key={index}>
              <div className="hc-step-container">
                <div className="hc-step-number-container">
                  <div className="hc-step-number">{process.step}</div>
                  <div className="hc-step-icon">{process.icon}</div>
                </div>
                <div className="hc-step-content">
                  <h3>{process.title}</h3>
                  <p className="hc-step-description">{process.desc}</p>
                  <ul className="hc-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < processSteps.length - 1 && <div className="hc-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      <section className="hc-faq-section">
        <div className="hc-faq-header">
          <span className="hc-section-tag">FAQs</span>
          <h2 className="hc-faq-title">Frequently Asked Questions</h2>
        </div>
        <div className="hc-faq-list">
          {faqData.map((faq, idx) => (
            <details className="hc-faq-item" key={idx}>
              <summary className="hc-faq-question">
                <span className="hc-faq-q">Q{idx + 1}:</span> {faq.q}
                <span className="hc-faq-toggle-icon">+</span>
              </summary>
              <div className="hc-faq-answer">
                <span className="hc-faq-a">A:</span> {faq.a}
              </div>
            </details>
          ))}
        </div>
      </section>
            <AutoScrollImageRow />


      {/* Modal for Image Viewing */}
      {isModalOpen && (
        <div className="hc-modal-overlay" onClick={closeModal}>
          <div
            className="hc-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="hc-close-modal" onClick={closeModal}>
              &times;
            </button>
            <img
              src={modalImage?.src}
              alt={modalImage?.alt}
              title={modalImage?.title || "STM Treatment Image"}
              className="hc-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Hair;
